export const REQUEST_CONTENT = 'REQUEST_CONTENT'
export const RECEIVE_CONTENT = 'RECEIVE_CONTENT'

export const requestContent = () => {
  return { type: REQUEST_CONTENT }
}

export const receiveContent = data => {
  return {
    type: RECEIVE_CONTENT,
    data,
  }
}
